import { useState } from "react";
import TeacherPortalQuestionStatistics from "./question/QuestionStatistics";
import TeacherPortalQuizQuestionSelector from "./QuizQuestionSelector";

const TeacherPortalQuizStatistics = ({ quizInformation }) => {
    const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(0)

    const selectedQuestion = quizInformation.questions[selectedQuestionIndex]

    return <>
        <div className="bg-white rounded shadow">
            <h2 className="p-4 text-2xl">{"Quiz: " + quizInformation.activitytitle}</h2>
            <div className="p-4">
                {
                    (
                        <>
                            <TeacherPortalQuizQuestionSelector questions={quizInformation.questions} functionToCallOnClickWithIndex={setSelectedQuestionIndex} />

                            {selectedQuestionIndex != undefined ?
                                <TeacherPortalQuestionStatistics selectedQuestion={selectedQuestion} selectedQuestionIndex={selectedQuestionIndex} /> : <></>
                            }
                        </>
                    )

                }
            </div>
        </div>
    </>
};

export default TeacherPortalQuizStatistics